export var EAutoFocusDisabledActionTypes;

(function (EAutoFocusDisabledActionTypes) {
  EAutoFocusDisabledActionTypes["SetAutoFocusDisabled"] = "autoFocusDisabled/set";
})(EAutoFocusDisabledActionTypes || (EAutoFocusDisabledActionTypes = {}));